import { VenueId } from '../../venues/venues.types';
import { useStateSelector } from '../../store/selectors';
import {
    canAccessVenue,
    getAccessibleVenues,
    getVenueAvailability,
    VenueAvailability,
} from '../../routing/access/venue-access-matrix';

export { canAccessVenue };

export const useAccessibleVenues = (): VenueId[] => {
    const summary = useStateSelector((state) => state.userSummary.summary);
    if (!summary) {
        return [];
    }
    return getAccessibleVenues(summary);
};

export const useVenueAvailability = (): ((venueId: VenueId) => VenueAvailability) => {
    const summary = useStateSelector((state) => state.userSummary.summary);
    return (venueId: VenueId) => getVenueAvailability(summary, venueId);
};
